export default __webpack_public_path__ + "static/media/2020 Protein Plus - content1.233de0c6.png";